export default __webpack_public_path__ + "static/media/pic14-1.e49e85ef.jpg";